import React, { useState } from "react";
import "./OrderTabs.css";
import { useSelector } from "react-redux";
import { useLocation, NavLink } from "react-router-dom";

const OTHERS_ROUTES = [
  "redispatch",
  "reverse",
  "processed",
  "inTransit",
  "cancelled",
  "delivered",
  "allOrders",
];

const OrdersTabs = (props) => {
  const stateData = useSelector((state) => state?.ActionReducer);
  const location = useLocation();

  const path = location.pathname.split("/");
  const pageName = path[path.length - 1];

  const isOthersActive = OTHERS_ROUTES.includes(pageName);

  // Keep sub-row open if currently on an Others route, otherwise default closed
  const [showOthers, setShowOthers] = useState(isOthersActive);

  const handleOthersClick = () => {
    setShowOthers((v) => !v);
  };

  if (path[2] === "rto") return null;

  return (
    <div className="new-tabs order-tabs">

      {/* ── ROW 1 : Primary tabs ── */}
      <div className="tab-container" style={{ position: "relative" }}>

        {/* Grab Order */}
        {stateData?.ordersCount?.grabOrders > 0 && (
          <div className="tab-container-inner">
            <NavLink
              to="graborder"
              className={`tabs grab ${pageName === "graborder" ? "cancel-active" : ""}`}
            >
              Grab Order
              <div className="order-menu-count-grab menu-count-border">
                {stateData.ordersCount.grabOrders}
              </div>
            </NavLink>
            <div className="popover-container">
              <img src="/cancel-arrow.webp" className="uparraow" />
              <div className="popover-content cancelBorderpop">
                <div className="pop-content">
                  <strong>Urgently required! </strong>Check availability and add pricing to add the products in your <strong>inventory</strong> and <strong>grab</strong> the order.
                </div>
              </div>
            </div>
          </div>
        )}
        {/* New Orders */}
        <div className="tab-container-inner">
          <NavLink
            to="unprocessed"
            className={`tabs ${pageName === "unprocessed" ? "active" : ""}`}
          >
            New Orders
            {stateData?.ordersCount?.newOrders > 0 && (
              <div className="order-menu-count menu-count-border">
                {stateData.ordersCount.newOrders}
              </div>
            )}
          </NavLink>
          <div className="popover-container">
            <img src="/pop-up-arrow.webp" className="uparraow" />
            <div className="popover-content greenBorderpop">
              <div className="pop-content">
                <strong>New assigned orders</strong> will be visible here. Once you <strong>generate</strong> and <strong>download</strong> the <strong>Manifest</strong>, order will be shift to <strong>"Ready to ship"</strong> Section
              </div>
            </div>
          </div>
        </div>

        <div className="tab-container-inner">
          <NavLink to="pickup-request" className={`tabs ${pageName == 'pickup-request' ? 'active' : ''}`}>
            Request for Pickup

            <div class="order-menu-count menu-count-border">{stateData?.ordersCount?.pickupRequest || 0}</div>
          </NavLink>
          <div class="popover-container">
            <img src="/pop-up-arrow.webp" className="uparraow" />
            <div class="popover-content greenBorderpop">
            <div className="pop-content">
                    The <strong>Request for Pickup</strong> tab will show all orders with generated manifests. You can generate the "pickup request" directly from this tab
                  </div>
            </div>
          </div>
        </div>

        {/* Ready to Ship */}
        <div className="tab-container-inner">
          <NavLink
            to="processed"
            className={`tabs ${pageName === "processed" ? "active" : ""}`}
          >
            Ready to Ship
            {stateData?.ordersCount?.readyToShipped > 0 && (
              <div className="order-menu-count menu-count-border">
                {stateData.ordersCount.readyToShipped}
              </div>
            )}
          </NavLink>
          <div className="popover-container">
            <img src="/pop-up-arrow.webp" className="uparraow" />
            <div className="popover-content greenBorderpop">
              <div className="pop-content">
                Once the manifest downloaded, <strong>orders</strong> will be visible here. Once the <strong>order shipped</strong>, it will shift to <strong>"Shipped"</strong> section.
              </div>
            </div>
          </div>
        </div>

        {/* Revoked */}
        <div className="tab-container-inner">
          <NavLink
            to="revoke"
            className={`tabs ${pageName === "revoke" ? "revoke-active" : ""}`}
          >
            Revoked
            {stateData?.ordersCount?.revoked > 0 && (
              <div className="order-menu-count menu-count-border revoke-order-count">
                {stateData.ordersCount.revoked}
              </div>
            )}
          </NavLink>
          <div className="popover-container">
            <img src="/revoke-arrow.webp" className="uparraow" />
            <div className="popover-content revokeBorderpop">
              <div className="pop-content">
                After assigning an order, <strong>if the order(s) get Revoked</strong> for any reason that will be <strong>visible</strong> here <strong>with reason</strong>
              </div>
            </div>
          </div>
        </div>
        

        {/* Others — clickable tab that toggles row 2 */}
        <div className="tab-container-inner">
          <div
            className={`tabs others-parent-tab ${isOthersActive || showOthers ? "active" : ""}`}
            onClick={handleOthersClick}
            style={{ cursor: "pointer", userSelect: "none" }}
          >
            Others
          </div>
        </div>

      </div>

      {/* ── ROW 2 : Others sub-tabs (shown when Others is toggled or active) ── */}
      {showOthers && (
        <div
          className="tab-container others-subtab-row"
          style={{ position: "relative", borderTop: "1px solid #e8e8e8" }}
        >

          {/* Support Redispatch */}
          <div className="tab-container-inner">
            <NavLink
              to="redispatch"
              className={`tabs ${pageName === "redispatch" ? "active" : ""}`}
            >
              Support Redispatch
              {stateData?.ordersCount?.Redispatch > 0 && (
                <div className="order-menu-count menu-count-border">
                  {stateData.ordersCount.Redispatch}
                </div>
              )}
            </NavLink>
            <div className="popover-container">
              <img src="/pop-up-arrow.webp" className="uparraow" />
              <div className="popover-content greenBorderpop">
                <div className="pop-content">
                  <strong>Redispatch orders</strong> will be visible here.
                </div>
              </div>
            </div>
          </div>

          {/* Support Reverse */}
          <div className="tab-container-inner">
            <NavLink
              to="reverse"
              className={`tabs ${pageName === "reverse" ? "active" : ""}`}
            >
              Support Reverse
              {stateData?.ordersCount?.reverseOrder > 0 && (
                <div className="order-menu-count menu-count-border">
                  {stateData.ordersCount.reverseOrder}
                </div>
              )}
            </NavLink>
            <div className="popover-container">
              <img src="/pop-up-arrow.webp" className="uparraow" />
              <div className="popover-content greenBorderpop">
                <div className="pop-content">
                  <strong>Reverse orders</strong> will be visible here. Reverse Order due to Support issues.
                </div>
              </div>
            </div>
          </div>

          {/* Shipped */}
          <div className="tab-container-inner">
            <NavLink
              to="inTransit"
              className={`tabs ${pageName === "inTransit" ? "active" : ""}`}
            >
              Shipped
              {stateData?.ordersCount?.shipped > 0 && (
                <div className="order-menu-count menu-count-border">
                  {stateData.ordersCount.shipped}
                </div>
              )}
            </NavLink>
            <div className="popover-container">
              <img src="/pop-up-arrow.webp" className="uparraow" />
              <div className="popover-content greenBorderpop">
                <div className="pop-content">
                  Once the <strong>order shipped</strong>, it will visible here. You can track the <strong>docket status</strong> by clicking <strong>"Track"</strong> option.
                </div>
              </div>
            </div>
          </div>

          {/* Cancelled */}
          <div className="tab-container-inner">
            <NavLink
              to="cancelled"
              className={`tabs ${pageName === "cancelled" ? "cancel-active" : ""}`}
            >
              Cancelled
              {stateData?.ordersCount?.cancelled > 0 && (
                <div className="order-menu-count menu-count-border cancle-order-count">
                  {stateData.ordersCount.cancelled}
                </div>
              )}
            </NavLink>
            <div className="popover-container">
              <img src="/cancel-arrow.webp" className="uparraow" />
              <div className="popover-content cancelBorderpop">
                <div className="pop-content">
                  After assigning an order, <strong>if the order(s) get Cancelled</strong> for any reason that will be <strong>visible</strong> here <strong>with reason</strong>
                </div>
              </div>
            </div>
          </div>

          {/* Delivered */}
          <div className="tab-container-inner">
            <NavLink
              to="delivered"
              className={`tabs ${pageName === "delivered" ? "active" : ""}`}
            >
              Delivered
              {stateData?.ordersCount?.delivered > 0 && (
                <div className="order-menu-count menu-count-border">
                  {stateData.ordersCount.delivered}
                </div>
              )}
            </NavLink>
            <div className="popover-container">
              <img src="/pop-up-arrow.webp" className="uparraow" />
              <div className="popover-content greenBorderpop">
                <div className="pop-content">
                  Once the order gets <strong>delivered</strong>, it will <strong>visible here.</strong>
                </div>
              </div>
            </div>
          </div>

          {/* All Orders */}
          <NavLink
            to="allOrders"
            className={`tabs ${pageName === "allOrders" ? "active" : ""}`}
          >
            All Orders
          </NavLink>

        </div>
      )}

    </div>
  );
};

export default OrdersTabs;